import Box from "@mui/material/Box";
import { useEffect } from "react";
import { useState } from "react";
import api from "../../../../config/api";
import EachPreference from "./EachPreference";

const PreferenceTableLine = ({ element }) => {
  const [descriptions, setDescriptions] = useState(() => element?.description);

  const addButton = (index, myRef) => {
    let newValue = "";
    let newDescriptions = [...descriptions];
    newDescriptions.splice(index + 1, 0, newValue);
    setDescriptions(() => newDescriptions);
    setTimeout(() => {
      myRef.current.scrollIntoView({ behavior: "smooth" });
    }, 150);
  };

  const handleDelete = (index) => {
    descriptions.splice(index, 1);
    setDescriptions([...descriptions]);
    updateDescriptions(descriptions);
  };

  const moveDown = (index, value) => {
    let newArray = descriptions;
    let indexToMove = index;
    let targetIndex = index;

    let element = newArray.splice(indexToMove, 1);
    let firstPart = newArray.slice(0, targetIndex + 1);
    let secondPart = newArray.slice(targetIndex + 1);

    newArray = firstPart.concat(element, secondPart);
    setDescriptions([...newArray]);
    updateDescriptions(newArray);
  };
  const moveUp = (index) => {
    let newArray = descriptions;
    let indexToMove = index;
    let targetIndex = index;

    let element = newArray.splice(indexToMove, 1);
    let firstPart = newArray.slice(0, targetIndex - 1);
    let secondPart = newArray.slice(targetIndex - 1);

    newArray = firstPart.concat(element, secondPart);
    setDescriptions([...newArray]);
    updateDescriptions(newArray);
  };

  const updateDescriptions = async (description = descriptions) => {
    await api.put(`/preferences-update/${element._id}`, { description: description });
  };

  useEffect(() => {
    updateDescriptions();
  }, [descriptions]);

  return (
    <>
      {descriptions.length ? (
        <>
          {descriptions.map((option, index) => (
            <>
              <Box
                className="d-flex border border-top-0 rounded justify-content-between align-items-center p-4 bg-white"
                noValidate
                autoComplete="off"
              >
                <EachPreference
                  {...{
                    handleDelete,
                    updateDescriptions,
                    descriptions,
                    index,
                    addButton,
                    option,
                    moveDown,
                    moveUp,
                    element,
                  }}
                />
              </Box>
            </>
          ))}
        </>
      ) : (
        <>
          <Box
            className="d-flex border border-top-0 rounded justify-content-between align-items-center p-4"
            noValidate
            autoComplete="off"
          >
            <EachPreference
              {...{ handleDelete, updateDescriptions, descriptions, addButton, moveDown, moveUp, element }}
            />
          </Box>
        </>
      )}
    </>
  );
};
export default PreferenceTableLine;
